import { useEffect, useState } from 'react';
import { EVENT_COLUMN, METRIC_COLUMN } from '../constants';
const useColumnSelector = (columns) => {
    const [showMetricsColumn, setShowMetricsColumn] = useState(false);
    const [events, setEvents] = useState([]);
    const [metrics, setMetrics] = useState([]);
    const [selected, setSelected] = useState([]);
    const conciliateMetrics = (prevMetrics, newMetrics) => {
        const conciliatedMetrics = [];
        newMetrics.forEach((newMetric) => {
            const prevMetric = prevMetrics.find((metr) => metr.value === newMetric.value);
            if (prevMetric) {
                conciliatedMetrics.push(Object.assign(Object.assign({}, newMetric), { pinned: prevMetric.pinned }));
            }
            else {
                const isSelectedColumn = selected.find((sel) => sel.value === newMetric.value);
                if (!isSelectedColumn) {
                    conciliatedMetrics.push(newMetric);
                }
            }
        });
        prevMetrics.forEach((prevMetric) => {
            const wasAddedBefore = conciliatedMetrics.find((conc) => conc.value === prevMetric.value);
            if (!wasAddedBefore) {
                const isSelectedColumn = selected.find((sel) => sel.value === prevMetric.value);
                if (!isSelectedColumn && !prevMetric.disabled) {
                    conciliatedMetrics.push(prevMetric);
                }
            }
        });
        return conciliatedMetrics;
    };
    useEffect(() => {
        const cols = Array.from(columns.values());
        const arrMetrics = cols
            .filter((column) => !column.selected && column.type === METRIC_COLUMN)
            .sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0));
        const arrEvents = cols.filter((column) => !column.selected && column.type === EVENT_COLUMN);
        const arrSelecteds = cols
            .filter((column) => column.selected || column.alwaysEnabled)
            .map((columnToMap) => (Object.assign(Object.assign({}, columnToMap), { selected: true })));
        const shouldShowMetricsColumn = cols.some((column) => column.type === METRIC_COLUMN);
        setShowMetricsColumn(shouldShowMetricsColumn);
        setMetrics(arrMetrics);
        setEvents(arrEvents);
        setSelected(arrSelecteds);
    }, []);
    useEffect(() => {
        const cols = Array.from(columns.values());
        const arrMetrics = cols
            .filter((column) => !column.selected && column.type === METRIC_COLUMN)
            .sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0));
        setMetrics((prevMetrics) => conciliateMetrics(prevMetrics, arrMetrics));
    }, [columns]);
    return {
        metrics,
        events,
        selected,
        showMetricsColumn,
        setEvents,
        setSelected,
        setMetrics,
    };
};
export default useColumnSelector;
//# sourceMappingURL=UseColumnSelector.js.map